<template>
	<div :class="classes"></div>
</template>

<script>
  export default {
    props: {
      split: {
        validator(value) {
          return ['vertical', 'horizontal'].indexOf(value) >= 0
        },
        required: true
      }
    },
    data() {
      const classes = ['Resizer', this.split, 'className'];
      return {
        classes: classes.join(' ')
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/common/components/extend/split-panel/resizer.vue